module.exports = __webpack_public_path__ + "img/chips_overlay.f5d4a9a5.jpeg";